import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Settings, Lightbulb, AlertTriangle, Star, Wand2, History, MessageSquare } from 'lucide-react';
import { LineChart, Line, ResponsiveContainer, XAxis, Tooltip } from 'recharts';
const data = [{
  name: 'M',
  hp: 60,
  pp: 50
}, {
  name: 'T',
  hp: 65,
  pp: 55
}, {
  name: 'W',
  hp: 75,
  pp: 60
}, {
  name: 'T',
  hp: 68,
  pp: 58
}, {
  name: 'F',
  hp: 85,
  pp: 70
}, {
  name: 'S',
  hp: 90,
  pp: 80
}, {
  name: 'S',
  hp: 78,
  pp: 65
}];
export function MyMirror() {
  const navigate = useNavigate();
  return <div className="max-w-3xl mx-auto p-8 pb-24" data-id="element-131">
      {/* Header */}
      <div className="flex items-center justify-between mb-8" data-id="element-132">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-gray-600 hover:bg-gray-100 rounded-full transition-colors" data-id="element-133">
          <ArrowLeft className="w-5 h-5" data-id="element-134" />
        </button>
        <button className="p-2 -mr-2 text-gray-600 hover:bg-gray-100 rounded-full transition-colors" data-id="element-135">
          <Settings className="w-5 h-5" data-id="element-136" />
        </button>
      </div>

      <div className="mb-8" data-id="element-137">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-138">My Mirror</h1>
        <p className="text-gray-500" data-id="element-139">See yourself clearly. Improve daily.</p>
      </div>

      {/* Tabs */}
      <div className="flex bg-gray-50 p-1 rounded-xl mb-8 border border-gray-100" data-id="element-140">
        {['Week', 'Month', 'Year', 'All Time'].map((tab, idx) => <button key={tab} className={`flex-1 py-2 text-sm font-medium rounded-lg transition-colors ${idx === 0 ? 'bg-gray-200 text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-141">
            {tab}
          </button>)}
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-3 gap-4 mb-8" data-id="element-142">
        <div className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100" data-id="element-143">
          <div className="text-xs font-medium text-gray-500 mb-1" data-id="element-144">
            HP Average
          </div>
          <div className="text-2xl font-bold text-gray-900 mb-2" data-id="element-145">78%</div>
          <div className="text-xs font-medium text-emerald-500 flex items-center gap-1" data-id="element-146">
            <LineChart className="w-3 h-3" data-id="element-147" /> Habits
          </div>
        </div>
        <div className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100" data-id="element-148">
          <div className="text-xs font-medium text-gray-500 mb-1" data-id="element-149">
            PP Average
          </div>
          <div className="text-2xl font-bold text-gray-900 mb-2" data-id="element-150">1h 45m</div>
          <div className="text-xs font-medium text-gray-400 flex items-center gap-1" data-id="element-151">
            — Deep Work
          </div>
        </div>
        <div className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100" data-id="element-152">
          <div className="text-xs font-medium text-gray-500 mb-1" data-id="element-153">
            Reflection
          </div>
          <div className="text-2xl font-bold text-gray-900 mb-2" data-id="element-154">12 days</div>
          <div className="text-xs font-medium text-rose-500 flex items-center gap-1" data-id="element-155">
            ⚡ Streak
          </div>
        </div>
      </div>

      {/* Chart */}
      <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 mb-8" data-id="element-156">
        <div className="flex items-center justify-between mb-6" data-id="element-157">
          <div className="flex items-center gap-2" data-id="element-158">
            <div className="p-1.5 bg-indigo-50 rounded-lg" data-id="element-159">
              <LineChart className="w-4 h-4 text-indigo-500" data-id="element-160" />
            </div>
            <h3 className="font-semibold text-gray-900" data-id="element-161">Execution Trends</h3>
          </div>
          <ArrowLeft className="w-4 h-4 text-gray-400 rotate-180" data-id="element-162" />
        </div>

        <div className="h-48 w-full bg-emerald-50/30 rounded-xl pt-4" data-id="element-163">
          <ResponsiveContainer width="100%" height="100%" data-id="element-164">
            <LineChart data={data} margin={{
            top: 5,
            right: 10,
            left: 10,
            bottom: 0
          }} data-id="element-165">
              <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
              fontSize: 10,
              fill: '#9CA3AF'
            }} dy={10} data-id="element-166" />
              <Tooltip contentStyle={{
              borderRadius: '8px',
              border: 'none',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
            }} data-id="element-167" />
              <Line type="monotone" dataKey="hp" stroke="#10B981" strokeWidth={3} dot={{
              r: 4,
              fill: '#10B981',
              strokeWidth: 0
            }} activeDot={{
              r: 6
            }} data-id="element-168" />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className="flex justify-center gap-6 mt-6" data-id="element-169">
          <div className="flex items-center gap-2 text-xs font-medium text-gray-500" data-id="element-170">
            <div className="w-2 h-2 rounded-full bg-emerald-500" data-id="element-171" /> HP %
          </div>
          <div className="flex items-center gap-2 text-xs font-medium text-gray-500" data-id="element-172">
            <div className="w-2 h-2 rounded-full bg-indigo-500" data-id="element-173" /> PP %
          </div>
        </div>
      </div>

      {/* Common Patterns */}
      <div className="mb-8" data-id="element-174">
        <h3 className="font-semibold text-gray-900 mb-4" data-id="element-175">Common Patterns</h3>
        <div className="space-y-3" data-id="element-176">
          <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100 flex items-start gap-4" data-id="element-177">
            <div className="p-2 bg-blue-50 rounded-full shrink-0" data-id="element-178">
              <Lightbulb className="w-5 h-5 text-blue-500" data-id="element-179" />
            </div>
            <p className="text-sm text-gray-700 leading-relaxed pt-0.5" data-id="element-180">
              You complete 91% of habits when you do deep work before 10am
            </p>
          </div>
          <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100 flex items-start gap-4" data-id="element-181">
            <div className="p-2 bg-rose-50 rounded-full shrink-0" data-id="element-182">
              <AlertTriangle className="w-5 h-5 text-rose-500" data-id="element-183" />
            </div>
            <p className="text-sm text-gray-700 leading-relaxed pt-0.5" data-id="element-184">
              Low energy is your #1 blocker on Wednesdays
            </p>
          </div>
          <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100 flex items-start gap-4" data-id="element-185">
            <div className="p-2 bg-rose-50 rounded-full shrink-0" data-id="element-186">
              <Star className="w-5 h-5 text-rose-500" data-id="element-187" />
            </div>
            <p className="text-sm text-gray-700 leading-relaxed pt-0.5" data-id="element-188">
              Your best HP days follow strong Wins in reflection
            </p>
          </div>
        </div>
      </div>

      {/* Top Wins & Blockers */}
      <div className="grid grid-cols-2 gap-8 mb-8" data-id="element-189">
        <div data-id="element-190">
          <h4 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-191">Top Wins</h4>
          <ul className="space-y-2" data-id="element-192">
            <li className="text-xs text-gray-600 flex items-center gap-2 before:content-['•'] before:text-gray-400" data-id="element-193">
              Morning Workout
            </li>
            <li className="text-xs text-gray-600 flex items-center gap-2 before:content-['•'] before:text-gray-400" data-id="element-194">
              Deep Work
            </li>
            <li className="text-xs text-gray-600 flex items-center gap-2 before:content-['•'] before:text-gray-400" data-id="element-195">
              Reading
            </li>
          </ul>
        </div>
        <div data-id="element-196">
          <h4 className="text-sm font-semibold text-rose-500 mb-3" data-id="element-197">
            Frequent Blockers
          </h4>
          <ul className="space-y-2" data-id="element-198">
            <li className="text-xs text-gray-600 flex items-center gap-2 before:content-['•'] before:text-gray-400" data-id="element-199">
              Social Media
            </li>
            <li className="text-xs text-gray-600 flex items-center gap-2 before:content-['•'] before:text-gray-400" data-id="element-200">
              Late Nights
            </li>
            <li className="text-xs text-gray-600 flex items-center gap-2 before:content-['•'] before:text-gray-400" data-id="element-201">
              Poor Planning
            </li>
          </ul>
        </div>
      </div>

      {/* Growth Suggestion */}
      <div className="bg-indigo-500 rounded-2xl p-6 text-white mb-8 shadow-sm" data-id="element-202">
        <div className="flex items-center gap-3 mb-3" data-id="element-203">
          <Wand2 className="w-5 h-5" data-id="element-204" />
          <h3 className="font-semibold" data-id="element-205">Growth Suggestion</h3>
        </div>
        <p className="text-sm text-indigo-100 leading-relaxed" data-id="element-206">
          Based on your last 30 days, try Dan Martell's habit stack — your
          energy is consistently higher on days you sweat first.
        </p>
      </div>

      {/* Actions */}
      <div className="space-y-3" data-id="element-207">
        <button className="w-full py-3 bg-white border border-gray-200 hover:bg-gray-50 text-gray-700 text-sm font-semibold rounded-xl shadow-sm transition-colors flex items-center justify-center gap-2" data-id="element-208">
          <History className="w-4 h-4" data-id="element-209" /> View Full History
        </button>
        <button className="w-full py-3 bg-slate-400 hover:bg-slate-500 text-white text-sm font-semibold rounded-xl shadow-sm transition-colors flex items-center justify-center gap-2" data-id="element-210">
          <MessageSquare className="w-4 h-4" data-id="element-211" /> Chat with My Journal
        </button>
        <button className="w-full py-3 text-indigo-600 hover:text-indigo-700 text-sm font-semibold transition-colors" data-id="element-212">
          Browse Habit Stacks
        </button>
      </div>
    </div>;
}